import { BRAND_NAME } from "../../constants/brand";
import { Divider, Grid, Link, Typography } from '@mui/material'
import homePageStyle from '../../Styles/ComponentStyles/LandingPage/HomePage.module.scss'
import { useContext } from 'react'
import { UserContext, UserContextPayload } from '../../Context/UserDetailContext'
import newRBLogo from '../../assets/Images/mar-lockup-white.svg'

const LandingPageFooter = () => {
    const {
        companyDetails
    } = useContext(UserContext) as UserContextPayload

    return (
        <Grid item xs={12} className={homePageStyle.footerSection}>
            <Grid container className={homePageStyle.footerInner}>
                <Grid
                    item
                    xs={12}
                    className={homePageStyle.footerHeader}
                    sx={{
                        display: 'flex',
                        justifyContent: { xs: 'flex-start', sm: 'flex-end' },
                        flexDirection: { xs: 'column', sm: 'row' },
                        alignItems: { xs: 'flex-start', sm: 'flex-end' },
                        textAlign: { xs: 'right', sm: 'left' },
                        paddingLeft: "30px"
                    }}
                >
                    <Link href="/terms-and-conditions" target="_blank">
                        <Typography className={homePageStyle.footerLink}>Terms and Conditions</Typography>
                    </Link>
                    <Link href="/privacy-policy" target="_blank">
                        <Typography className={homePageStyle.footerLink}>Privacy Policy</Typography>
                    </Link>
                    <Link href="/user-agreement" target="_blank">
                        <Typography className={homePageStyle.footerLink}>User Agreement</Typography>
                    </Link>
                </Grid>
                <Divider
                    style={{
                        opacity: 0.4,
                        borderColor: "#fff",
                        height: "0.5px",
                        width: "100%",
                        margin: "10px auto"
                    }}
                />
                <Grid item xl={11} lg={11.5} md={12} sm={12} xs={12}>
                    <Grid container className={homePageStyle.footerContent}>
                        <Grid item xl={3} lg={3} md={4} sm={12} xs={12} padding={"0px 0px 0px 30px"}>
                            <Grid container>
                                <Grid item xs={12} marginBottom={"20px"}>
                                    <img src={newRBLogo} alt={BRAND_NAME} />
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography className={homePageStyle.footerText}>
                                        Empowering financial professionals with cutting
                                        edge technology to deliver exceptional retirement
                                        planning solutions and build secure futures for
                                        their clients
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Divider sx={{ borderColor: "#fff", opacity: "0.4" }} orientation="vertical" flexItem />
                        <Grid item xl={8} lg={8} md={7} sm={12} xs={12}>
                            <Typography className={homePageStyle.footerContentText}>
                                This presentation is a general discussion of the topic presented, based on our current understanding of applicable tax laws, regulations, and rulings. This information and presentation in no way should be interpreted as investment or tax advice. In actual practice, the transactions discussed may be more complex and will require the attention and expertise of professional tax and legal advisors. In order to comply with certain U.S. Treasury regulations, please be advised of the following: unless expressly stated otherwise, any reference to U.S. Federal tax information contained in these materials, including any attachments, is not intended or written to be used, and cannot be used, by any person for the purpose of avoiding any penalties that may be imposed by the Internal Revenue Service. Values and benefits are not guaranteed unless stated as guaranteed on illustrations. Examples are used to illustrate the potential benefits of indexed universal life insurance / IRS SEC. 7702 & 72(e). Portions of this presentation are based on NAIC compliant life insurance illustrations which must be present during the presentation and fully reviewed for additional disclosures.
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Divider
                    style={{
                        opacity: 0.4,
                        borderColor: "#fff",
                        height: "0.5px",
                        width: "100%",
                        margin: "10px auto"
                    }}
                />
                <Grid item xs={11}>
                    <Typography className={homePageStyle.footerRightsText} textAlign={"center"}>
                        © {new Date().getFullYear()} {BRAND_NAME}. All rights reserved.
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default LandingPageFooter
